import React from 'react'
import Navbar from '../header/Navbar'
import Footer from '../footer/Footer'
import CryptoPortFolio from '../games/crypto/Crypto'

const Crypto = () => {
  return (
    <div>
      <Navbar/>
      <CryptoPortFolio/>
      <Footer/>
    </div>
  )
}

export default Crypto